import { jsx as _jsx } from "react/jsx-runtime";
import { useModalStore } from '../../stores/index.js';
import { Waiting } from '../Waiting/Waiting.js';
export const AwaitingPasswordStep = () => {
    const isLogin = useModalStore(state => state.isLogin());
    return (_jsx(Waiting, { heading: isLogin ? 'Waiting for Password' : 'Creating Password', subheading: "Follow the prompts presented by your browser." }));
};
